export default __webpack_public_path__ + "static/media/WNLProto2.56eee764.png";